import React, { useEffect, useState } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import REB_Logo from "../../../assets/REB_Logo.png";
import RTB_Logo from "../../../assets/RTB_Logo.png";

import { Box } from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { connect } from "react-redux";

import { TreeItem, TreeView } from "@mui/lab";

import { useRequiredAuth } from "../guard/requiredAuth";

const DrawerContent = (props) => {
  const {
    drawerState,
    setDrawerState,
    onDrowerItemClicked,
    user,
    env,
    version,
    userModules,
  } = props;

  const { hasPermissions } = useRequiredAuth();
  const location = useLocation();
  const history = useHistory();

  const [expanded, setExpanded] = useState([]);

  useEffect(() => {
    if (!!userModules[0]) setExpanded([userModules[0].id]);
  }, [userModules]);

  const handleToggleNode = (event, nodeIds) => {
    setExpanded(nodeIds);
  };

  return (
    <React.Fragment>
      <div
        id="drawer"
        className={`position-fixed ${drawerState ? "active" : ""}`}
      >
        <div>
          <div className="drawer-logo">
            {user?.selectedScope?.id === "REB" && (
              <img src={REB_Logo} className="" alt="Linda Miller" />
            )}
            {user?.selectedScope?.id === "RTB" && (
              <img src={RTB_Logo} className="" alt="Linda Miller" />
            )}
          </div>
          <div style={{ marginTop: "0px" }}>
            <div style={{ backgroundColor: "#015198", height: "7px" }}></div>
          </div>
          <Box
            sx={{ height: "73vh", flexGrow: 1, overflowY: "auto" }}
            className="mt-2 pr-2"
          >
            <TreeView
              aria-label="controlled"
              defaultCollapseIcon={<ExpandMoreIcon />}
              defaultExpandIcon={<ChevronRightIcon />}
              expanded={expanded}
              onNodeToggle={handleToggleNode}
            >
              <TreeItem
                className={`nav-item ${
                  location.pathname.includes("/in/welcome") ? "active" : ""
                }`}
                nodeId="1"
                label={
                  <Link onClick={onDrowerItemClicked} to="/in/welcome">
                    <span
                      className="d-flex justify-content-between  align-items-center"
                      style={{ maxWidth: "100%" }}
                    >
                      <span
                        style={{
                          cursor: "default",
                        }}
                      >
                        Welcome
                      </span>
                    </span>
                  </Link>
                }
              />
              {env !== "prod" && (
                <TreeItem
                  className={`nav-item ${
                    location.pathname.includes("/in/dev-tools") ? "active" : ""
                  }`}
                  nodeId="dev-tools-test-notifications"
                  label={
                    <Link
                      onClick={onDrowerItemClicked}
                      to="/in/dev-tools/test-notifications"
                    >
                      <span
                        className="d-flex justify-content-between align-items-center"
                        style={{ maxWidth: "100%" }}
                      >
                        <span style={{ cursor: "default" }}>
                          Test Notifications ({env})
                        </span>
                      </span>
                    </Link>
                  }
                />
              )}
              {userModules.map((mod) =>
                !!mod.features ? (
                  <TreeItem
                    key={mod.id}
                    className={`nav-item`}
                    nodeId={mod.id}
                    label={
                      <span
                        className="d-flex justify-content-between  align-items-center"
                        style={{ maxWidth: "100%" }}
                      >
                        <span className={`d-block text-truncate`}>
                          <span
                            className="mr-2 menu-header"
                            style={{
                              cursor: "default",
                            }}
                          >
                            {mod.name}
                          </span>
                        </span>
                      </span>
                    }
                  >
                    {mod.features
                      ?.sort((a, b) => {
                        return a.orderNo - b.orderNo;
                      })
                      .filter(
                        (feature) =>
                          !feature.requiredPermissions?.length ||
                          hasPermissions(feature.requiredPermissions),
                      )
                      .map((feature) => (
                        <TreeItem
                          key={feature.id}
                          className={`nav-item ${
                            location.pathname.includes(`${feature.url}`)
                              ? "active"
                              : ""
                          }`}
                          nodeId={feature.id}
                          label={
                            <Link
                              onClick={onDrowerItemClicked}
                              to={feature.url}
                            >
                              <span
                                className="d-flex justify-content-between  align-items-center"
                                style={{ maxWidth: "100%" }}
                              >
                                <span className={`d-block text-truncate`}>
                                  <span
                                    className="mr-2"
                                    style={{
                                      cursor: "default",
                                    }}
                                  >
                                    {feature.name}
                                  </span>
                                </span>
                              </span>
                            </Link>
                          }
                        />
                      ))}
                  </TreeItem>
                ) : (
                  <TreeItem
                    key={mod.id}
                    className={`nav-item ${
                      location.pathname.includes(`${mod.url}`) ? "active" : ""
                    }`}
                    nodeId={mod.id}
                    label={
                      <Link onClick={onDrowerItemClicked} to={mod.url}>
                        <span
                          className="d-flex justify-content-between  align-items-center"
                          style={{ maxWidth: "100%" }}
                        >
                          <span
                            style={{
                              cursor: "default",
                            }}
                          >
                            {mod.name}
                          </span>
                        </span>
                      </Link>
                    }
                  />
                ),
              )}
            </TreeView>
          </Box>
        </div>

        <div className="text-center pt-3">
          {!!version && <span>TMIS V.{version}</span>}
        </div>
      </div>

      <div
        id="drawer-void"
        className={`position-fixed ${
          drawerState ? "d-block d-lg-none" : "d-none"
        } `}
        onClick={() => {
          setDrawerState(false);
          onDrowerItemClicked();
        }}
      ></div>
    </React.Fragment>
  );
};

const mapStateToProps = ({ user, env, version, userModules }) => {
  return { user, env, version, userModules };
};

export default connect(mapStateToProps, {})(DrawerContent);
